module.exports = __webpack_public_path__ + "img/sy_14@2x.a17e5263.png";